import { Tooltip } from '@hive/component';
import { useI18n } from '@hive/i18n';

import { ellipsisTextStyle } from './index.css';
type FilterTagProps = {
  name: string;
};

const useFilterTag = ({ name }: FilterTagProps) => {
  const t = useI18n();
  switch (name) {
    case 'Created':
      return t['Created']();
    case 'Updated':
      return t['Updated']();
    case 'Tags':
      return t['Tags']();
    case 'Is Favourited':
      return t['com.hive.filter.is-favourited']();
    case 'Is Public':
      return t['com.hive.filter.is-public']();
    case 'after':
      return t['com.hive.filter.after']();
    case 'before':
      return t['com.hive.filter.before']();
    case 'last':
      return t['com.hive.filter.last']();
    case 'is':
      return t['com.hive.filter.is']();
    case 'is not empty':
      return t['com.hive.filter.is not empty']();
    case 'is empty':
      return t['com.hive.filter.is empty']();
    case 'contains all':
      return t['com.hive.filter.contains all']();
    case 'contains one of':
      return t['com.hive.filter.contains one of']();
    case 'does not contains all':
      return t['com.hive.filter.does not contains all']();
    case 'does not contains one of':
      return t['com.hive.filter.does not contains one of']();
    case 'true':
      return t['com.hive.filter.true']();
    case 'false':
      return t['com.hive.filter.false']();
    default:
      return name;
  }
};

export const FilterTag = ({ name }: FilterTagProps) => {
  const tag = useFilterTag({ name });

  return (
    <Tooltip content={tag}>
      <span className={ellipsisTextStyle} data-testid={`filler-tag-${tag}`}>
        {tag}
      </span>
    </Tooltip>
  );
};
